import React from 'react';
import {
    Box,
    H1,
    Container,
    Grid,
} from '@saladbob/sassafras'

import Image from '../../components/media/Image';
import getSite from '../../crud/getSite';
import Layout from '../../components/Layout';
import RichText from '../../components/blocks/RichText/RichText';

import type { NextPageWithLayout, PageProps } from '../_app';
import type { Hof } from '../../types';

type Props = {
    Header: React.FC,
    hof: Hof,
};

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking', // can also be true or 'blocking'
    }
}

export async function getStaticProps({ params }) {
    console.log(params);
    const site = await getSite();
    const hof = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/hof/${params.id}`).then((res) => res.json());

    return {
        props: {
            hof: hof,
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = ({ hof }) => {
    return (
        <Box bgColor="black" txtColor="white">
            <Container size="lg">
                <Grid
                    columns={{ phone: '1fr', laptop: '1fr 2fr' }}
                    minHeight="auto"
                    height="100%"
                    gridGap="lg"
                    padding={{ phone: 'md', laptop: 'xl' }} 
                >
                    {hof.image && (
                        <Image
                            image={hof.image}
                            size="card"
                            alt={hof.caption}
                            loading="lazy"
                            objectFit="contain"
                            bgColor="transparent"
                            height="460px"
                        />
                    )}
                    <div>
                        <H1 font="jumbo" mb="0">{hof.year}</H1>
                        <H1 font={{ phone: 'jumbo', laptop: 'giant' }} mb="0" color="primary">{hof.caption || hof.fullName}</H1>
                    </div>
                </Grid>
                <RichText content={hof.content} horizontalPadding="xl" />
            </Container>
        </Box>
    );
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps ) {
    return (
        <Layout { ...pageProps }>
            {page}
        </Layout>
    )
}

export default Page;